<skl-dialog-content-ins>
	<skl-dialog-header-ins
		[title]="'scenes.accountancy.service.dialog.download.title' | translate"
		id="accountancy-download-data-exchange-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			<ins-checkbox
				class="align--medium-top align--medium-bottom"
				[(ngModel)]="viewModel.params.compression"
				id="accountancy-download-data-exchange-dialog-compression"
				[label]="'scenes.accountancy.service.dialog.download.form.compression.label' | translate"
				[readonly]="viewModel.params.compressionOnly">
			</ins-checkbox>
			@if (viewModel.params.compression) {
				<ins-form-field
					[label]="'scenes.accountancy.service.dialog.download.form.password.label' | translate">
					<skl-password-ins
						[(ngModel)]="viewModel.params.password"
						id="accountancy-download-data-exchange-dialog-compression-password"
						[placeholder]="'scenes.accountancy.service.dialog.download.form.password.placeholder' | translate">
					</skl-password-ins>
				</ins-form-field>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="accountancy-download-data-exchange-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.accountancy.service.dialog.download.form.download-exchange-data-file.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			typeName="accent"
			id="accountancy-download-data-exchange-dialog-confirm-button"
			[spinner]="isDownloading"
			(click)="downloadDocumentAsync()">
			{{ 'scenes.accountancy.service.dialog.download.form.download-exchange-data-file.buttons.download' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>